export enum UsersSortBy {
  NAME = 'name',
  EMAIL = 'email',
}
